export const ENDPOINT = process.env.NODE_ENV === 'development' ? "http://127.0.0.1:3333" : "https://api.ihore.id";
// export const SOCK_POINT = process.env.NODE_ENV === 'development' ? "http://127.0.0.1:5200" : "https://ws.ihore.id";
export const SOCK_POINT = process.env.NODE_ENV === 'development' ? "http://127.0.0.1:5200" : "https://ws.ihore.id";
export const DEFAULT_FULL_ACCESS = 3
export const DEFAULT_WRITE_ACCESS = 2
export const DEFAULT_READ_ACCESS = 1

// baseUrl: process.env.NODE_ENV == 'development' ? 'http://localhost:8080/' : 'https://demo.simades.id/', // khusus untuk gambar
// baseUrlA: process.env.NODE_ENV == 'development' ? 'http://localhost:8080' : 'https://demo.simades.id', // khusus untuk gambar
// baseApi: process.env.NODE_ENV == 'development' ? 'http://localhost:8080/api' : 'https://demo.simades.id/api',